<template>
<v-app id="login" light>
  <v-layout style="margin-top:1em;">
    <v-flex v-if="!splashScreen">
      <v-hover>
        <template v-slot:default="{ hover }">
          <v-card :elevation="hover ? 12 : 6" class="pa-2 mx-auto rounded-xl transition-swing" style="max-width: 400px;">
            <v-card-title >
              <v-img :src='images.logoSmall' contain class="mx-auto" :aspect-ratio="16/10" alt='logo'></v-img>
            </v-card-title>
            <v-card-text>
                {{ message }}
              <v-progress-linear v-show="valid" :indeterminate="true"></v-progress-linear>
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="!goodAuth" class="elevation-1" :to="{ name: 'login' }" color="primary" light block>
                Se connecter avec mon login
              </v-btn>
              <v-btn v-if="goodAuth" class="elevation-1" :to="{ name: 'dashboard' }" color="primary" light block>
                Aller sur le dashboard
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-hover>
    </v-flex>
    <v-flex v-if="splashScreen" class="mt-1">
      <v-row align="center" justify="center">
        <v-img :src='images.logoSmall' alt='logo' max-height="150" contain></v-img>
      </v-row>
      <div class="text-center text-h2 font-weight-bold mt-9">Chargement des données</div>
      <v-progress-linear v-if="splashScreen" :indeterminate="true"></v-progress-linear>
    </v-flex>
  </v-layout>
  <v-alert prominent type="error" v-if="!isLocalStorageAvailable">
    <v-row align="center">
      <v-col class="grow">
        Vous devez activer le LocalStorage pour utiliser l'application
      </v-col>
      <v-col class="shrink">
        
      </v-col>
    </v-row>
  </v-alert>
</v-app>
</template>

<script>
import { actions } from "@/stores/auth.module"

export default {
  name: 'login-component',
  data () {
    return {
      goodAuth: false,
      valid: true,
      images: {
        logoSmall: require('@/assets/logo.svg')
      },
      message: 'Tentative de connexion en cours...',
      splashScreen: false
    }
  },
  computed: {
    isLocalStorageAvailable() {
      try {
          const testKey = "__test__";
          window.localStorage.setItem(testKey, testKey);
          window.localStorage.removeItem(testKey);
          return true;
      } catch (e) {
          return false;
      }
    }
  },
  mounted:function (){
    this.loginWithMagic()
  },
  methods: {
    async loginWithMagic(){
      if( ( this.$route.params.token ) && this.$route.params.token.length > 3 ){
        this.goodAuth = await actions.loginWithToken({magicToken: this.$route.params.token, grant_type: 'magic_link'}) //authorization_code
        if( this.goodAuth ){
          // Get redirect from query params (Vue Router 3.x syntax)
          const redirect =  '/'
          // Force next tick for iOS to render splash screen first
          this.$nextTick(() => {
            this.$router.push(redirect).catch(err => {
              // Ignore navigation duplication errors
              if (err.name !== 'NavigationDuplicated') {
                console.error('Router error:', err)
              }
            })
          })
        } else {
          setTimeout(() => {
            this.valid = true
            this.message = 'Lien non valide ou expiré'
          }, 500)
        }
      } else {
        setTimeout(() => {
          this.valid = true
          this.message = 'Lien non valide'
        }, 1000)
      }
    }
  }
}
</script>

<style lang="css">
/* Personnalisation code */
.login-container {
  transform: translate(0, -50px);
  padding-top: 2em;
}
.login-paper {
  width: 24em;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
}
.login-logo {
  margin-bottom: 1.2em;
  padding-top: 0.5em;
}

</style>